import { render, staticRenderFns } from "./DSHeadings.vue?vue&type=template&id=75ab6f80&"
import script from "./DSHeadings.vue?vue&type=script&lang=js&"
export * from "./DSHeadings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports